module.exports = __webpack_public_path__ + "static/media/scene8_furba2.6ac7c8ea.wav";